import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosInstance } from '../../../utils/axios';

export const createPortfolioSegment = createAsyncThunk(
  'portfolioSegment/createPortfolioSegment',
  async (segmentData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('api/v1/collections/segmentation/', segmentData);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const fetchPortfolioSegments = createAsyncThunk(
  'portfolioSegment/fetchPortfolioSegments',
  async (_, { rejectWithValue }) => {
    try {
      const url = 'api/v1/control/financial-product/';

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSegments = createAsyncThunk('portfolioSegment/fetchSegments', async (_, { rejectWithValue }) => {
  try {
    const url = 'api/v1/collections/segmentation/';

    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return rejectWithValue(error.response.data);
    }
    return rejectWithValue(error.message);
  }
});

export const updatePortfolioSegment = createAsyncThunk(
  'portfolioSegment/updatePortfolioSegment',
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const url = `api/v1/collections/segmentation/${uuid}/`;
      const response = await axiosInstance.patch(url, data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deletePortfolioSegment = createAsyncThunk(
  'portfolioSegment/deletePortfolioSegment',
  // el primer argumento será el uuid a eliminar
  async (uuid, { rejectWithValue }) => {
    try {
      const url = `api/v1/collections/segmentation/${uuid}`;
      const response = await axiosInstance.delete(url);
      // devuelve lo que retorne tu API (puede ser un objeto vacío)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Nuevo thunk para obtener subsegmentos

export const createPortfolioSubsegment = createAsyncThunk(
  'portfolioSegment/createPortfolioSubsegment',
  async (segmentData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('api/v1/collections/subsegmentation/', segmentData);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const fetchSubsegments = createAsyncThunk(
  'portfolioSegment/fetchSubsegments',
  async (_, { rejectWithValue }) => {
    try {
      const url = 'api/v1/collections/subsegmentation/';

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSubsegment = createAsyncThunk(
  'portfolioSegment/deletePortfolioSubsegment',
  // el primer argumento será el uuid a eliminar
  async (uuid, { rejectWithValue }) => {
    try {
      const url = `api/v1/collections/subsegmentation/${uuid}`;
      const response = await axiosInstance.delete(url);
      // devuelve lo que retorne tu API (puede ser un objeto vacío)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateSubSegment = createAsyncThunk(
  'portfolioSegment/updateSubSegment',
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const url = `api/v1/collections/subsegmentation/${uuid}/`;
      const response = await axiosInstance.patch(url, data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const fetchAsignaciones = createAsyncThunk(
  'portfolioSegment/fetchAsignaciones',
  async (filters, { rejectWithValue }) => {
    try {
      const url = 'api/v1/collections/recovery-assign-by-manager/';

      // Construir los query params a partir de los filtros
      const params = filters || {};
      const response = await axiosInstance.get(url, { params });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const portfolioSegmentSlice = createSlice({
  name: 'portfolioSegment',
  initialState: {
    data: null,
    segmentsList: [],
    segments: [],
    subsegments: [],
    asginaciones: [],
    isLoading: false,
    error: null,
    success: false,
    listLoading: false,
    listError: null,
  },
  reducers: {
    resetPortfolioSegmentState: (state) => {
      state.data = null;
      state.isLoading = false;
      state.error = null;
      state.success = false;
      state.updateSuccess = false;
    },
    resetListState: (state) => {
      state.segmentsList = [];
      state.segments = [];
      state.subsegments = [];
      state.listLoading = false;
      state.listError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPortfolioSegment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createPortfolioSegment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.success = true;
      })
      .addCase(createPortfolioSegment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Ocurrió un error al crear el segmento.';
        state.success = false;
      })
      // --- Manejo de estados para fetchPortfolioSegments (GET) ---
      .addCase(fetchPortfolioSegments.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchPortfolioSegments.fulfilled, (state, action) => {
        state.listLoading = false;
        state.segmentsList = action.payload.results;
      })
      .addCase(fetchPortfolioSegments.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al obtener los segmentos.';
      })
      // --- Manejo de estados para deletePortfolioSegment  ---
      .addCase(deletePortfolioSegment.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(deletePortfolioSegment.fulfilled, (state, action) => {
        state.listLoading = false;
      })
      .addCase(deletePortfolioSegment.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al borrar el segmento.';
      })
      // --- Manejo de estados para updatePortfolioSegment ---
      .addCase(updatePortfolioSegment.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
        state.updateSuccess = false;
      })
      .addCase(updatePortfolioSegment.fulfilled, (state, action) => {
        state.listLoading = false;
        state.updateSuccess = true;
      })
      .addCase(updatePortfolioSegment.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al actualizar el segmento.';
        state.updateSuccess = false;
      })
      // --- Manejo de estados para fetchSegments (GET) ---
      .addCase(fetchSegments.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchSegments.fulfilled, (state, action) => {
        state.listLoading = false;
        state.segments = action.payload;
      })
      .addCase(fetchSegments.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al obtener los segmentos.';
      })
      .addCase(createPortfolioSubsegment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createPortfolioSubsegment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.success = true;
      })
      .addCase(createPortfolioSubsegment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Ocurrió un error al crear el subSegmento.';
        state.success = false;
      })
      // --- Manejo de estados para fetchSubsegments (GET) ---
      .addCase(fetchSubsegments.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchSubsegments.fulfilled, (state, action) => {
        state.listLoading = false;
        state.subsegments = action.payload;
      })
      .addCase(fetchSubsegments.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al obtener los subsegmentos.';
      })
      .addCase(deleteSubsegment.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(deleteSubsegment.fulfilled, (state, action) => {
        state.listLoading = false;
      })
      .addCase(deleteSubsegment.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al borrar el subsegmento.';
      })
      // --- Manejo de estados para updateSubSegment ---
      .addCase(updateSubSegment.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
        state.updateSuccess = false;
      })
      .addCase(updateSubSegment.fulfilled, (state, action) => {
        state.listLoading = false;
        state.updateSuccess = true;
      })
      .addCase(updateSubSegment.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Ocurrió un error al actualizar el subsegmento.';
        state.updateSuccess = true;
      })
      .addCase(fetchAsignaciones.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAsignaciones.fulfilled, (state, action) => {
        state.loading = false;
        state.asginaciones = action.payload;
      })
      .addCase(fetchAsignaciones.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPortfolioSegmentState, resetListState } = portfolioSegmentSlice.actions;
export const selectSegments = (state) => state.portfolioSegment.segments;
export const selectSubsegments = (state) => state.portfolioSegment.subsegments;

export default portfolioSegmentSlice.reducer;
